import { Component, OnInit, Input, ChangeDetectionStrategy } from "@angular/core";
import { FormControl } from "@angular/forms";

import { TopicFormService } from "../../services/topic-form.service";

@Component({
  selector: "onsip-video-checkbox",
  templateUrl: "./video-checkbox.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  // NO STYLESHEETS HERE
  standalone: false
})
export class VideoCheckboxComponent implements OnInit {
  @Input() initialValue: boolean | undefined;
  @Input() set disabled(disabled: boolean) {
    if (this.formControl) {
      if (disabled) {
        this.formControl.disable();
      } else {
        this.formControl.enable();
      }
    }
    this._disabled = disabled;
  }

  formControl!: FormControl;
  private _disabled!: boolean;

  constructor(private topicForm: TopicFormService) {}

  ngOnInit() {
    this.formControl = new FormControl(
      typeof this.initialValue === "undefined" ? true : this.initialValue
    );
    if (this._disabled) {
      this.formControl.disable();
    } else {
      this.formControl.enable();
    }
    this.topicForm.addControl("video", this.formControl);
  }
}
